"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioEpisodeLocalizedReferenceSchema = void 0;
exports.AudioEpisodeLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/audio-episodes.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "AudioEpisodeLocalizedReference",
    "description": "An episode of an audio series (either a podcast series or a radio show)",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:audio-episodes"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXVkaW8tZXBpc29kZXMuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL21vZHVsZXMvcmVmZXJlbmNlL2xvY2FsaXplZC9jb250ZW50L2F1ZGlvLWVwaXNvZGVzLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG9DQUFvQyxHQUFHO0lBQ2xELEtBQUssRUFBRSx3RkFBd0Y7SUFDL0YsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsZ0NBQWdDO0lBQ3pDLGFBQWEsRUFBRSx5RUFBeUU7SUFDeEYsTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTiw0QkFBNEI7YUFDN0I7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSxpR0FBaUc7U0FDN0c7S0FDRjtDQUNGLENBQUEifQ==